import {observer} from "mobx-react";
import classNames from 'classnames';
import styles from "../modals/AddEditBlockModal/styles/AddOrEditBlock.module.scss";
import Selector from "../admin/utilities/Selector";
import {localeRegistry} from "../../internationalization/SupportedLocales";
import {useStores} from "../../stores/useStores";

const OrgSupportedLocaleSelector = observer((props: {
    disabled: boolean,
    handleSelectorChange: (value: string) => void,
    className?: string,
    value: string,
}) => {
    const {i18nStore} = useStores();
    const {disabled, handleSelectorChange, className} = props;

    const selectorClassName = classNames({
        "form-control": true,
        [styles.selector]: true,
        [styles.selectorDisabled]: disabled,
    });

    return <div className={className}>
        <label>Language</label>
        <div>
            <Selector className={selectorClassName}
                      disabled={disabled}
                      options={i18nStore.organizationSupportedLocales.map(locale => {
                          return {
                              value: locale,
                              title: localeRegistry[locale]._englishName,
                          };
                      })}
                      onChange={handleSelectorChange}
                      value={props.value}
            />
        </div>
    </div>
});

export default OrgSupportedLocaleSelector;
